import React from 'react'
import IconifyIcon from '../../../wrapper/IconifyIcon'
import { logEvent } from '../../../../config/firebase'

const links = [
  {
    badge: 'QO',
    icon: 'mdi:web',
    label: 'Visitar Quantum Odds',
    name: 'quantum_odds_site',
    url: 'https://quantumodds.xyz/',
  },
  {
    badge: 'PM',
    icon: 'logos:telegram',
    label: 'PolyMidas no Telegram',
    name: 'polymidas',
    url: 'https://t.me/polymarket_market_aim_bot',
  },
  {
    badge: 'FM',
    icon: 'logos:telegram',
    label: 'Price Drop - Filter Market no Telegram',
    name: 'price_drop_filter_market',
    url: 'https://t.me/price_drop_ai_bot',
  },
]

const TelegramSocialLinks = () => (
  <div className="topbar-social-links" aria-label="Links externos">
    {links.map((link) => (
      <a
        aria-label={link.label}
        className="topbar-social-link"
        href={link.url}
        key={link.name}
        onClick={() => logEvent('header_social_click', { destination: link.name })}
        rel="noopener noreferrer"
        target="_blank"
        title={link.label}
      >
        <IconifyIcon icon={link.icon} width="18" />
        <small>{link.badge}</small>
      </a>
    ))}
  </div>
)

export default TelegramSocialLinks
